function login(credentials) {
  return fetch(
    `${process.env.REACT_APP_FREEVIEW_API_URL}/officialsite/v1/tool_login`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    }
  );
}

function getQiNiuUpToken(token) {
  return fetch(
    `${process.env.REACT_APP_FREEVIEW_API_URL}/officialsite/v1/tool_uptoken`,
    {
      method: "GET",
      headers: {
        "x-token-id": token,
      },
    }
  );
}

function getWeixinQrcode(scene, token) {
  return fetch(
    `${process.env.REACT_APP_FREEVIEW_API_URL}/officialsite/v1/gain_ticket`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-token-id": token,
      },
      body: JSON.stringify({ scene_str: scene }),
    }
  );
}

function getVideoUrl(id) {
  return fetch(
    `${process.env.REACT_APP_FREEVIEW_API_URL}/officialsite/v1/gain_url?code=${id}`
  );
}

function fetchWechatShareSignature() {
  return fetch(
    `${process.env.REACT_APP_WECHAT_API}/third/v1/wx/get/token`
  );
}

export {
  login,
  getQiNiuUpToken,
  getWeixinQrcode,
  getVideoUrl,
  fetchWechatShareSignature,
};
